"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "berzo-demo": {
    "a4ade79f": [{
      "hkey": "06fc9dc3",
      "slug": "berzo-demo",
      "name": "Berzo Demo",
      "primary": true,
      "skipSearch": false
    }],
    "bettolino": [{
      "hkey": "06fc9dc3",
      "slug": "berzo-demo",
      "name": "Berzo Demo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da303084": [{
      "hkey": "06fc9dc3",
      "slug": "berzo-demo",
      "name": "Berzo Demo",
      "primary": true,
      "skipSearch": false
    }],
    "lorengo": [{
      "hkey": "06fc9dc3",
      "slug": "berzo-demo",
      "name": "Berzo Demo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e5654868": [{
      "hkey": "644a4efa",
      "slug": "berzo",
      "name": "Berzo",
      "primary": true,
      "skipSearch": false
    }],
    "paesi-berzo": [{
      "hkey": "644a4efa",
      "slug": "berzo",
      "name": "Berzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;